import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom'
import VerifyRegisterOpt from '../controllers/VerifyRegisterOpt';
import SharedPublicRoutes from './SharedPublicRoutes';
import HomeController from '../controllers/HomeController';
import DashBoardLayout from "./DashboardLayout";
import CheckoutController from "../controllers/CheckoutController";
import AttractionDetailController from "../controllers/AttractionDetailController";
import LocationDetailController from "../controllers/LocationDetailController";
import ProductFilterController from "../controllers/ProductFilterController";
import ProductDetailController from "../controllers/ProductDetailController";
import LoginController from "../controllers/LoginController";
import SignupController from "../controllers/SignupController";
import ForgotPaswordController from "../controllers/ForgotPaswordController";
import BlogDetailController from '../controllers/BlogDetailController';
import BlogController from '../controllers/BlogController';
import BlogCategoryDetailController from '../controllers/BlogCategoryDetailController';
import BlogCategoryController from '../controllers/BlogCategoryController';
import AuthLayout from './AuthLayout';

export default function VerificationRoutes() {
    return (
        <>
            <Routes>
                <Route path="/" element={<AuthLayout />}>
                    <Route path="/:lang/verify" element={<VerifyRegisterOpt />} />
                    <Route path="/verify" element={<Navigate to="/en/verify" replace />} />

                    <Route path="/:lang/login" element={<LoginController />} />
                    <Route path="/login" element={<Navigate to="/en/login" replace />} />

                    <Route path="/:lang/signup" element={<SignupController />} />
                    <Route path="/signup" element={<Navigate to="/en/signup" replace />} />

                    <Route path="/:lang/forgot-password" element={<ForgotPaswordController view="forgot" />} />
                    <Route path="/forgot-password" element={<Navigate to="/en/forgot-password" replace />} />

                    <Route path="/:lang/reset-password/:token" element={<ForgotPaswordController view="reset" />} />
                    {/* <Route path="/reset-password/:token" element={<Navigate to="/en/reset-password/:token" replace />} /> */}
                </Route>

                {/* <Route path="/" element={<DashBoardLayout />}>
                    <Route path="/home" element={<HomeController />} />
                    <Route path="/tour/:slug" element={<ProductDetailController />} />
                    <Route path="/location/*" element={<LocationDetailController />} />
                    <Route path="/product/:slug" element={<LocationDetailController />} />
                    <Route path="/attraction/:slug" element={<AttractionDetailController />} />
                    <Route path="/search" element={<ProductFilterController />} />
                    <Route path="/checkout" element={<CheckoutController />} />
                    <Route path="/blog" element={<BlogController />} />
                    <Route path="/blog/article/:slug" element={<BlogDetailController />} />
                    <Route path="/blog/category" element={<BlogCategoryController />} />
                    <Route path="/blog/category/:slug" element={<BlogCategoryDetailController />} />
                    <Route path="/" element={<HomeController />} />
                    <Route path="*" element={<HomeController />} />
                </Route> */}
            <Route path="/" element={<DashBoardLayout />}>
                <Route path="*" element={<HomeController />} />
            </Route>
            </Routes>
        </>
    )

}